__turbopack_context__.v({
  "fullWidth": "Gold-module__Yetq2q__fullWidth",
  "label": "Gold-module__Yetq2q__label",
  "root": "Gold-module__Yetq2q__root",
});
